import './assets/main.css'

import * as Sentry from "@sentry/vue"
import { createApp } from 'vue'
import App from './App.vue'
import i18n from './utils/i18n.js'
import * as amplitude from '@amplitude/analytics-browser'

const app = createApp(App)
const mode = import.meta.env.VITE_ENV

if (["production", "staging"].includes(mode)) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: mode,

    // TODO: lower sample rate once we have enough data (after Q4 2024)
    tracesSampleRate: 1.0,
  })

  amplitude.init(import.meta.env.VITE_AMPLITUDE_KEY, {
    defaultTracking: false,
    useDynamicConfig: true
  })
}

if (mode === 'production') {

} else if (mode === 'staging') {
  (async () => {
    const eruda = await import('eruda')
    if (!eruda._isInit) {
      eruda.init()
    }
  })()
}

app.use(i18n)
app.mount('#app')
